import $http from "superagent";
import { message } from "ant-design-vue";
import { Tacitly } from "./Tacitly";
import clickThrottle from "./timer";
import store from "@/store";
import router from "@/router";
import { set } from "core-js/core/dict";
import { bus } from '@/assets/js/bus.js'
// 添加全局变量控制token失效提示
let isTokenExpiredPromptShown = false;
let tokenExpiredPromptTimer = null;

export function ajax({
  url = "", //请求
  data = {}, //data
  type = "post", // 默认post
  contentType = "application/x-www-form-urlencoded",
  hastoken = true,
  head = null,
  updateTime = null,
  success = () => {},
  fail = () => {},
  complete = () => {},
} = parameter) {
  let urlStr = url + JSON.stringify(data) + type, //请求拼接
    fieldurls = [];
  let isContinue = fieldurls.some((v) => {
    return v == urlStr;
  });
  if (isContinue) {
    console.log("请求被拦截:", urlStr, "当前pending请求:", fieldurls);
    //拦截重复请求
    return false;
  } else {
    //允许请求
    fieldurls.push(urlStr);
  }
  if (hastoken && !localStorage.getItem("t")) {
    localStorage.clear();
  }
  let p = new Promise((resolve, reject) => {
    let $put;
    let newdata = JSON.parse(JSON.stringify(data));
    if (type == "get") {
      for (const key in newdata) {
        // 去除对象内多余的空值key
        if (
          (!newdata[key] &&
            typeof newdata[key] == "string" &&
            typeof newdata[key] != "number") ||
          newdata[key] === null
        ) {
          delete newdata[key];
        }
      }
    }
    //  else {
    //   if (!clickThrottle()) return;
    // }
    (($put = $http
      .delete(Tacitly.Base_Port + url)
      .set("Content-Type", contentType)
      .send(newdata)) &&
      type == "delete") ||
      (($put = $http
        .put(Tacitly.Base_Port + url)
        .set("Content-Type", contentType)
        .send(newdata)) &&
        type == "put") ||
      (($put = $http
        .put(Tacitly.Base_Port + url)
        .set("Content-Type", contentType)) &&
        type == "delete") ||
      (($put = $http
        .get(Tacitly.Base_Port + url)
        .set("Content-Type", contentType)
        .query(newdata)) &&
        type == "get") ||
      (($put = $http
        .post(Tacitly.Base_Port + url)
        .withCredentials()
        .set("Content-Type", contentType)
        .send(newdata)) &&
        type == "post");
    if (hastoken) {
      $put.set({ authorization: localStorage.getItem("t") });
    }
    if (updateTime) {
      $put.set("resubmit-update-time", updateTime);
    }
    $put.end((err, res) => {
      let data = res.body;
      fieldurls.pop(); //请求返回 删去该url
      if (data.code == "0000") {
        success(data.data);
        resolve(data.data);
        if (store.state.updateTime && updateTime) {
          store.dispatch("settime", null);
        }
      } else if (data.code == "1001") {
        //token失效 - 添加防重复提示机制
        if (!isTokenExpiredPromptShown) {
          isTokenExpiredPromptShown = true;
          message.error(data.msg);
          // 设置定时器，1.5秒后重置提示状态并跳转
          tokenExpiredPromptTimer = setTimeout(() => {
            store.dispatch("openkey", { key: 'filemanage', by: false })
            store.dispatch("openkey", { key: 'chat', by: false })
            store.dispatch("openkey", { key: 'PopUpFileInformation', by: false })
            localStorage.clear();
            bus.$emit('token-expired');
            router.push("/login"); 
            
            // 2秒后重置提示状态，防止后续请求继续提示
            setTimeout(() => {
              isTokenExpiredPromptShown = false;
            }, 2000);
          }, 1500);
        }
        fail(data);
        reject();
      } else {
        message.error(data.msg);
        fail(data);
        reject();
      }
    });
  });
  return p;
}
